import axios from 'axios';

export const createFormikValidation = (formMap, values) => {
	const errors = {};

	for (let [key, value] of formMap) {
		if (!values[key]) {
			errors[key] = "O campo " + value + " é obrigatório."
		}
	}

	return errors;
};

export const shallowEqual = (object1, object2) => {
	const keys1 = Object.keys(object1);
	const keys2 = Object.keys(object2);

	if (keys1.length !== keys2.length) {
		return false;
	}

	for (let key of keys1) {
		if (object1[key] !== object2[key]) {
			return false;
		}
	}

	return true;
};

export const formatHourInput = input => {
	let value = input.target.value;

	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{2})(\d)/, "$1:$2");

	input.target.value = value;

	return input;
};

export const formatCNPJInput = input => {
	let value = input.target.value;

	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{2})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d)/, "$1/$2");
	value = value.replace(/(\d{4})(\d{1,2})$/, "$1-$2");

	input.target.value = value;

	return input;
};

export const formatCPF = (value) => {
	if (!value) return '';
	return value
		.replace(/\D/g, '')
		.replace(/(\d{3})(\d)/, '$1.$2')
		.replace(/(\d{3})(\d)/, '$1.$2')
		.replace(/(\d{3})(\d{1,2})/, '$1-$2')
		.replace(/(-\d{2})\d+?$/, '$1');
};

export const formatCPFInput = input => {
	let value = input.target.value;
	input.target.value = formatCPF(value);

	return input;
};

export const formatDataInput = input => {
	let value = input.target.value;

	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{2})(\d)/, "$1/$2");
	value = value.replace(/(\d{2})(\d)/, "$1/$2");

	input.target.value = value;

	return input;
};

export const formatTelefone = value => {
	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{0})(\d)/, "$1($2");
	value = value.replace(/(\d{2})(\d)/, "$1) $2");
	value = value.replace(/(\d{1})(\d{1,4})$/, "$1-$2");
	return value;
};

export const formatTelefoneInput = input => {
	let value = input.target.value;
	input.target.value = formatTelefone(value);
	return input;
};

export const formatCepInput = input => {
	let value = input.target.value;

	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{5})(\d)/, "$1-$2");

	input.target.value = value;

	return input;
};

export const formatBRLInput = input => {
	input.target.value = Number(input.target.value.toString().replace(/[^0-9-]/g, '')) / 10 ** 2;

	input.target.value = formatBRL(input.target.value);

	return input;
};

export const formatBRL = value => {
	const cleanValue = Number(value) || 0;
	const formatter = new Intl.NumberFormat('pt-BR', {
		style: 'currency',
		currency: 'BRL',
		minimumFractionDigits: 2
	});

	value = formatter.format(cleanValue);

	return value;
};

export const formatPercentageInput = input => {
	input.target.value = Number(input.target.value.toString().replace(/[^0-9-]/g, '')) / 10 ** 2;

	let percentageHigherThan100 = input.target.value >= 1 ? true : false;

	if (percentageHigherThan100) {
		input.target.value = formatPercentage(1);
	} else {
		input.target.value = formatPercentage(input.target.value);
	}

	return input;
};

export const formatPercentage = value => {
	const formatter = new Intl.NumberFormat('pt-BR', {
		style: 'percent',
		maximumFractionDigits: 2
	});

	value = formatter.format(value);

	return value;
};

export const buscaCep = (input, setFieldValue, nomeEndereco, nomeBairro, nomeCidade, nomeUf) => {
	if (input.target.value.length > 8) {
		var cep = input.target.value.replace(/[^0-9]/, "");

		const instance = axios.create();

		instance.get(`https://viacep.com.br/ws/${cep}/json/`, {}).then(res => {
			setFieldValue(nomeEndereco, res.data.logradouro);
			setFieldValue(nomeBairro, res.data.bairro);
			setFieldValue(nomeCidade, res.data.localidade);
			setFieldValue(nomeUf, res.data.uf);
		}).catch(err => {
		});
	}

	return formatCepInput(input);
};

export const limparMoeda = (valor) => {
	valor = valor.replace("%", "");
	valor = valor.replace("R$", "");
	valor = valor.replace(".", "");
	valor = valor.replace(",", ".");
	// eslint-disable-next-line
	valor = valor.replace('/^\p{Z}+|\p{Z}+$/u', '');
	valor = valor.trim();

	return valor
};

export const listaUfs = [
	'AC',
	'AL',
	'AM',
	'AP',
	'BA',
	'CE',
	'DF',
	'ES',
	'GO',
	'MA',
	'MG',
	'MS',
	'MT',
	'PA',
	'PB',
	'PE',
	'PI',
	'PR',
	'RJ',
	'RN',
	'RO',
	'RR',
	'RS',
	'SC',
	'SE',
	'SP',
	'TO'
];

export const displayValueCurrency = (value) => {
	return value ? `R$ ${value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` : "Não disponível";
};

export const displayValueFixed = (value, casas) => {
	return value ? value.toFixed(casas) : "Não disponível";
};

export const displayValuePercent = (value) => {
	return value ? `${value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })} %` : "Não disponível";
};

export const shippingOptions = () => {
	return [
		{
			label: "Comer aqui",
			type: "COMER_AQUI"
		},
		{
			label: "Área externa / Deck",
			type: "AREA_EXTERNA"
		},
		{
			label: "Levar para casa",
			type: "LEVAR_CASA"
		},
	];
};

export const getShippingOptionsLabel = (type) => {
	let options = shippingOptions();

	let option = options.filter(obj => {
		return obj.type === type
	});

	return option[0];
}

export const removeAccents = (str) => {
	const map = {
		'-': '_',
		'a': 'á|à|ã|â|ä|À|Á|Ã|Â|Ä',
		'e': 'é|è|ê|ë|É|È|Ê|Ë',
		'i': 'í|ì|î|ï|Í|Ì|Î|Ï',
		'o': 'ó|ò|ô|õ|ö|Ó|Ò|Ô|Õ|Ö',
		'u': 'ú|ù|û|ü|Ú|Ù|Û|Ü',
		'c': 'ç|Ç',
		'n': 'ñ|Ñ'
	};

	for (var pattern in map) {
		str = str.replace(new RegExp(map[pattern], 'g'), pattern);
	}

	return str;
}

export const formatPhoneNumber = (phoneNumberString) => {
	let cleaned = ('' + phoneNumberString).replace(/\D/g, '');

	let match = cleaned.match(/^(\d{2})(\d{4,5})(\d{4})$/);

	if (match) {
		return '(' + match[1] + ') ' + match[2] + '-' + match[3];
	}

	return null;
};

export const apenasNumerosPositivos = (input, maximo = null) => {
	if (!maximo) {
		let valor = input.target.value;

		if (valor.length <= 1) valor = valor.replace(/[^1-9]/g, '');

		valor = valor.replace(' ', '');
		valor = valor.replace(/[^0-9]/g, '');
		valor = valor.trim();

		input.target.value = valor;

		return input;
	} else {
		let valor = input.target.value;

		if (valor.length <= 1) valor = valor.replace(/[^1-9]/g, '');

		valor = valor.replace(' ', '');
		valor = valor.replace(/[^0-9]/g, '');
		valor = valor.trim();

		input.target.value = valor > maximo ? maximo : valor;

		return input;
	}
};

export const verificaHoraValida = (hora = '') => {
	if (hora === '') return false;

	if (!hora.match(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/)) return false;

	return true;
};


export const formatPlacaInputFilter = input => {
	let value = input.target.value;

	value = value.replace("-", "");
	value = value.replace(/(\D{3})(\w{4})$/, "$1-$2").toUpperCase();

	return value;

};

export const formatCNPJInputFilter = input => {
	let value = input.target.value;

	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{2})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d)/, "$1/$2");
	value = value.replace(/(\d{4})(\d{1,2})$/, "$1-$2");

	return value;
};

export const formatCPFInputFilter = input => {
	let value = input.target.value;

	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{3})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");


	return value;
};

export const formatCNPJ = value => {
	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{2})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d)/, "$1/$2");
	value = value.replace(/(\d{4})(\d{1,2})$/, "$1-$2");

	return value;
};


export const limparTelefone = (valor) => {
	valor = valor.replace(' ', '');
	valor = valor.replace('-', '');
	valor = valor.replace('(', '');
	valor = valor.replace(')', '');
	valor = valor.replace('/[^A-Za-z0-9\-]/', '');
	valor = valor.replace('/-+/', '-');
	valor = valor.trim();

	return valor;
};

export const formatHourInputFilter = input => {
	let value = input.target.value;

	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{2})(\d)/, "$1:$2");



	return value;
};

export const formatFullDate = (date) => {
	if (!date) return '';

	const dateObject = new Date(date);
	const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
	const formattedDate = dateObject.toLocaleDateString('pt-BR', options);

	const parts = formattedDate.split(', ');
	const dayOfWeek = parts[0];
	const restOfDate = parts[1].split(' de ');

	return `${dayOfWeek}, ${restOfDate[0]} de ${restOfDate[1]} de ${restOfDate[2]}`;
}

export const hasPermission = (userPermissions, requiredPermission) => {
	if (!userPermissions || !Array.isArray(userPermissions)) {
		return false;
	}
	if (Array.isArray(requiredPermission)) {
		return requiredPermission.some(permission => userPermissions.includes(permission));
	}
	return userPermissions.includes(requiredPermission);
};

export const baixarArquivo = async (url, nomeArquivo) => {
	try {
		const resposta = await fetch(url);
		const blob = await resposta.blob();
		const blobUrl = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.href = blobUrl;
		link.download = nomeArquivo;
		document.body.appendChild(link);
		link.click();
		link.remove();
		URL.revokeObjectURL(blobUrl);
	} catch (e) {
		window.open(url, '_blank', 'noopener,noreferrer');
	}
};
